module.exports = __webpack_public_path__ + "static/media/logo.28973a59.png";